var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useMemo } from 'react';
import { Box, Button, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getCodigoOfertaFormatada, MODOS } from '../../../utils';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { useAuth } from '../../../contexts/auth/AuthContext';
import GridBase from '../../../components/grid_base';
import GridComp from '../../../components/grid';
import { BoxGrid } from '../../../components/grid_box';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import { getOfertasVagasTrabalhos, getCombosListarVagas } from './selecao_profissionais.service';
import { FiltrosVagas } from '../components/FiltrosVagas';
// Colunas fixas para o modal de Vagas
var COLUNAS_VAGAS = [
    {
        field: 'id',
        headerName: 'Código',
        description: 'Código da Vaga',
        width: 100,
        valueGetter: function (_value, row) { return "".concat(getCodigoOfertaFormatada(row.id)); },
    },
    {
        field: 'descricao',
        headerName: 'Descrição',
        description: 'Descrição da Vaga',
        width: 250,
    },
    {
        field: 'perfil_laboral',
        headerName: 'Perfil',
        width: 250,
        valueGetter: function (_value, row) { var _a; return (_a = row.perfil_laboral) === null || _a === void 0 ? void 0 : _a.nome; },
    },
    {
        field: 'salario',
        headerName: 'Salário',
        width: 100,
    },
    {
        field: 'quantidade_vagas',
        headerName: 'QTD',
        description: 'Quantidade de Vagas',
        width: 100,
    },
    {
        field: 'tipo_status_vaga',
        headerName: 'Status',
        description: 'Status da Vaga',
        width: 250,
        valueGetter: function (value) { return value; },
    },
];
export var SelecaoProfissionaisListar = function () {
    var _a;
    var navigate = useNavigate();
    // Estado apenas para controlar o Modal de Vagas
    var _b = useState(false), popupAberto = _b[0], setPopupAberto = _b[1];
    var _c = useState(null), ofertaSelecionada = _c[0], setOfertaSelecionada = _c[1];
    var getFuncionalidadeExiste = useAuth().getFuncionalidadeExiste;
    var abrirPopup = function (oferta) {
        setOfertaSelecionada(oferta);
        setPopupAberto(true);
    };
    var fecharPopup = function () {
        setPopupAberto(false);
        setOfertaSelecionada(null);
    };
    // Colunas da Grid Principal protegidas com useMemo
    var colunasOfertas = useMemo(function () { return [
        {
            field: 'id',
            headerName: 'Código',
            description: 'Código da Oferta',
            width: 100,
            valueGetter: function (_value, row) { return "".concat(getCodigoOfertaFormatada(row.id)); },
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            description: 'Descrição da Oferta',
            width: 200,
        },
        {
            field: 'instituicao',
            headerName: 'Instituição',
            width: 250,
            valueGetter: function (_value, row) { var _a, _b; return (_b = (_a = row.instituicao) === null || _a === void 0 ? void 0 : _a.dados) === null || _b === void 0 ? void 0 : _b.razao_social; },
        },
        {
            field: 'vagas_qtd',
            headerName: 'QTD',
            description: 'Quantidade de Vagas Solicitadas',
            width: 100,
        },
        {
            field: 'situacao_oferta',
            headerName: 'Status',
            description: 'Status da Oferta',
            width: 150,
            valueGetter: function (value) { return value; },
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 140,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [_jsx(Tooltip, __assign({ title: 'Visualizar Vagas', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return abrirPopup(params.row); } }, { children: _jsx(VisibilityOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })), _jsx(Tooltip, __assign({ title: 'Visualizar', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'terceary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 1, marginTop: -1 }, onClick: function () { return navigate("".concat(ROUTES.SELECAO_PROFISSIONAIS_VAGAS, "/").concat(params.row.id, "/").concat(MODOS.VISUALIZAR)); } }, { children: _jsx(AssignmentIndIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) })), _jsx(Tooltip, __assign({ title: 'Alterar', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(Box, __assign({ bgcolor: 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { return navigate("".concat(ROUTES.OFERTAS_VAGAS_TRABALHO, "/").concat(params.row.id, "/").concat(MODOS.ALTERAR)); } }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })) }))] }))); },
        },
    ]; }, [navigate]);
    return (_jsxs(_Fragment, { children: [_jsx(GridBase, { pagina: PAGINAS.SELECAO_PROFISSIONAIS, paginaPermissao: FUNCIONALIDADES.SELECAO_PROFISSIONAIS, columns: colunasOfertas, hideAddButton: true, botoesAcoesCustomizados: function () { return null; }, filtrosIniciais: {
                    status: '-1',
                    instituicao: -1,
                    perfilLaboral: -1,
                    dataInicio: '',
                    dataFim: '',
                }, fetchData: function (textoBusca, filtros, paginationModel) {
                    var _a, _b;
                    var tipoRegime = null;
                    var temFechado = getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_FECHADO);
                    var temSemiaberto = getFuncionalidadeExiste(FUNCIONALIDADES.ATENDIMENTOS_REGIME_SEMIABERTO);
                    if (temFechado && !temSemiaberto) {
                        tipoRegime = 'Fechado';
                    }
                    else if (!temFechado && temSemiaberto) {
                        tipoRegime = 'Semiaberto';
                    }
                    return getOfertasVagasTrabalhos(textoBusca === '' ? null : textoBusca, filtros.status === '-1' ? null : filtros.status, filtros.instituicao === -1 ? null : (_a = filtros.instituicao) === null || _a === void 0 ? void 0 : _a.toString(), filtros.perfilLaboral === -1 ? null : (_b = filtros.perfilLaboral) === null || _b === void 0 ? void 0 : _b.toString(), filtros.dataInicio === '' ? null : filtros.dataInicio, filtros.dataFim === '' ? null : filtros.dataFim, tipoRegime, paginationModel);
                }, renderFiltros: function (filtros, atualizarFiltros) { return (_jsx(FiltrosVagas, { filtrosAtuais: filtros, atualizarFiltros: atualizarFiltros, getCombosListar: getCombosListarVagas })); } }), _jsxs(Dialog, __assign({ open: popupAberto, onClose: fecharPopup, maxWidth: 'lg', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Vagas - Oferta ".concat(getCodigoOfertaFormatada(ofertaSelecionada === null || ofertaSelecionada === void 0 ? void 0 : ofertaSelecionada.id)) }), _jsx(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: _jsx(BoxGrid, { children: _jsx(GridComp, { columns: COLUNAS_VAGAS, rows: (ofertaSelecionada === null || ofertaSelecionada === void 0 ? void 0 : ofertaSelecionada.vagas) || [], TotalRegistros: ((_a = ofertaSelecionada === null || ofertaSelecionada === void 0 ? void 0 : ofertaSelecionada.vagas) === null || _a === void 0 ? void 0 : _a.length) || 0, initialState: {
                                    sorting: {
                                        sortModel: [{ field: 'id', sort: 'asc' }],
                                    },
                                } }) }) })), _jsx(DialogActions, __assign({ style: { padding: 20 } }, { children: _jsx(Button, __assign({ onClick: fecharPopup }, { children: "Cancelar" })) }))] }))] }));
};
export default SelecaoProfissionaisListar;
